<template>
  <div class="side-menu aside-box-shadow">
    <div class="system-title">
      <span class="system-span" v-if="!isCollapse">系统功能</span>
      <div :class="systemCollapseClass" @click="isCollapse = !isCollapse">
        <svg :class="systemArrowClass" v-html="svgData.systemCollapseSvg"/>
      </div>
    </div>
    <el-menu class="menu-list" :default-active="menuActive" @select="menuSelect" :collapse="isCollapse"
             :collapse-transition="false" :unique-opened="true">
      <template v-for="item0 in menuList0">
        <!-- 一级目录 -->
        <el-submenu v-if="item0.menuType === 0" :index="item0.menuCode" :key="item0.rid" class="first-menu">
          <template slot="title">
            <svg class="menu-icon" v-html="svgData[item0.menuIcon]"/>
            <span slot="title">{{ item0.menuTitle }}</span>
          </template>
          <el-menu-item v-show="isCollapse">
            <template slot="title">
              <span slot="title">{{ item0.menuTitle }}</span>
            </template>
          </el-menu-item>
          <template v-for="item1 in menuList1">
            <!-- 二级目录 -->
            <el-submenu v-if="item1.menuType === 0 && item1.menuNotice.indexOf(item0.menuNotice + '.') === 0"
                        class="second-menu" :index="item1.menuCode" :key="item1.rid">
              <template slot="title">
                <i class="menu-icon" :class="item1.menuIcon"/>
                <span slot="title">{{ item1.menuTitle }}</span>
              </template>
              <el-menu-item v-show="isCollapse">
                <template slot="title">
                  <span slot="title">{{ item1.menuTitle }}</span>
                </template>
              </el-menu-item>
              <template v-for="item2 in menuList2">
                <el-menu-item
                    v-if="(item2.menuType === 1 || item2.menuType === 2) && item2.menuNotice.indexOf(item1.menuNotice + '.') === 0"
                    :index="item2.menuCode" :key="item2.rid" class="third-menu">
                  <div class="menu-item">
                    <i class="menu-icon third-menu-icon filled chis-icon-filled-check" style="color: #A5C0DB"/>
                    <span slot="title">{{ item2.menuTitle }}</span>
                  </div>
                </el-menu-item>
              </template>
            </el-submenu>
            <!--二级 内部菜单或外部链接 -->
            <el-menu-item
                v-else-if="(item1.menuType === 1 || item1.menuType === 2) && item1.menuNotice.indexOf(item0.menuNotice + '.') === 0"
                :index="item1.menuCode" :key="item1.rid" class="second-menu">
              <template slot="title">
                <div class="menu-item">
                  <i class="menu-icon" :class="item1.menuIcon"/>
                  <span slot="title">{{ item1.menuTitle }}</span>
                </div>
              </template>
            </el-menu-item>
          </template>
        </el-submenu>
        <!-- 内部菜单或外部链接 -->
        <el-menu-item v-else-if="item0.menuType === 1 || item0.menuType === 2" :index="item0.menuCode" :key="item0.rid"
                      class="first-menu">
          <svg class="menu-icon" v-html="svgData[item0.menuIcon]"/>
          <span slot="title">{{ item0.menuTitle }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import svgData from './svg-data.js'

export default {
  name: 'SideMenu',
  data() {
    return {
      api: this.$store.state.api,
      svgData: svgData,
      isCollapse: false,
      menuActive: '',
      menuList: [],
      menuList0: [],
      menuList1: [],
      menuList2: [],
    }
  },
  created() {
    this.loadSystemMenu()
  },
  mounted() {
  },
  computed: {
    systemCollapseClass() {
      return this.isCollapse ? 'system-collapse-open system-collapse-close' : 'system-collapse-open'
    },
    systemArrowClass() {
      return this.isCollapse ? 'system-arrow-left system-arrow-right' : 'system-arrow-left'
    },
  },
  methods: {
    menuListSplit() {
      for (let i = 0, length = this.menuList.length; i < length; i++) {
        if (this.menuList[i].menuType > 0 && this.menuList[i].menuUrl.indexOf('http') !== 0) {
          this.menuList[i].menuUrl = this.$store.state.baseUrl + '#' + this.menuList[i].menuUrl
        }
        if (this.menuList[i].menuNotice.split('.').length === 1) {
          this.menuList0.push(this.menuList[i])
        } else if (this.menuList[i].menuNotice.split('.').length === 2) {
          this.menuList1.push(this.menuList[i])
        } else if (this.menuList[i].menuNotice.split('.').length === 3) {
          this.menuList2.push(this.menuList[i])
        }
      }
      this.$nextTick(() => {
        if (this.$CommonTools.verifyIsNotBlank(this.initMenu)) {
          this.menuSelect(this.initMenu)
        } else {
          for (let i = 0, length = this.menuList.length; i < length; i++) {
            if (this.menuList[i] && this.menuList[i].menuType == 1) {
              this.menuSelect(this.menuList[i].menuCode)
              break
            }
          }
        }
      })
    },
    systemMenuIcon(menuIcon) {
      return this.$store.state.baseUrl + 'img/menu/' + menuIcon
    },
    menuSelect(key) {
      this.menuSelectNormal(key, false, '')
    },
    menuSelectNormal(key, refresh, obj) {
      for (let i = 0, length = this.menuList.length; i < length; i++) {
        if (this.menuList[i].menuCode === key) {
          if (this.menuList[i].menuType === 1) {
            this.$emit('menuSelectHandler', this.menuList[i].menuCode, this.menuList[i].menuTitle, this.menuList[i].menuUrl + obj, refresh)
          } else if (this.menuList[i].menuType === 2) {
            this.$system.windowOpenBlank(this.menuList[i].menuUrl)
          }
          this.menuActive = this.menuList[i].menuCode
          break
        }
      }
    },
    tabMenu(name) {
      this.menuActive = name
    },
    //加载系统菜单
    loadSystemMenu() {
      let data = {}
      this.$system.get(
          this.api + '/systematic/getUserMenuList-1', data, true, true,
          data => {
            if (data.type === '00') {
              this.menuList = this.menuList.concat(data.menuList)
              this.menuListSplit()
            } else {
              this.$system.notify('错误', data.mess, 'error')
            }
          },
          () => {
            this.$system.notify('错误', '网络连接失败', 'error')
          }
      )
    },
  },
}
</script>

<style lang="less" >
.side-menu {
  .system-title {
    position: relative;
    height: 46px;
    line-height: 46px;
  }

  .system-icon {
    width: 16px;
    height: 16px;
    margin-left: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }

  .system-span {
    color: #484a50;
    padding-left: 12px;
    font-family: "Harmony Bold" !important;
    font-size: 16px;
    vertical-align: middle;
  }

  .system-collapse-open {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 50%;
    right: 12px;
    margin-top: -12px;
    vertical-align: middle;
    cursor: pointer;
  }

  .system-collapse-open:hover {
    background: linear-gradient(90deg, #f6fbff, #f0f7ff);
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 #e4e7ef;
  }

  .system-collapse-close {
    right: 16px;
  }

  .system-arrow-left {
    position: absolute;
    width: 14px;
    height: 14px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .system-arrow-right {
    -webkit-transform: rotateZ(180deg);
    transform: rotateZ(180deg);
  }

  .el-menu--collapse {
    width: 56px;
  }

  .menu-list {
    border-right: 0;
    background-color: #1f2d3d;
  }

  .menu-list:not(.el-menu--collapse) {
    width: 230px;
  }

  .menu-icon {
    width: 20px;
    height: 20px;
    color: #355F87 !important;
    margin-right: 10px;
    position: relative;
    top: -1px;
  }

  .second-menu-icon, .third-menu-icon {
    width: 16px;
    height: 16px;
    margin-right: 13px;
  }

  .third-menu-icon {
    margin-bottom: 0;
  }

  .el-menu--collapse img {
    width: 24px;
    height: 24px;
    margin-left: 4px;
  }

  .menu-circular {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #bdc1d1;
    margin-top: -3px;
    margin-right: 4px;
  }

  /deep/ .el-submenu__icon-arrow:before {
    content: '\e6e0' !important;
  }


  .el-menu {
    background: none !important;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    color: #1f2d3d !important;
    font-size: 14px !important;
    padding: 4px 12px 4px 10px !important;
    border-top: 1px solid rgba(220, 221, 223, 0.7) !important;
    background-color: #ffffff !important;
    vertical-align: middle !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
  }

  /**
  一级菜单
   */

  .first-menu.el-menu-item, .first-menu .el-submenu__title {
    font-size: 16px !important;
    height: 52px !important;
    line-height: 46px !important;
  }

  .el-menu-item.is-active.first-menu, .el-menu-item:focus.first-menu, .el-menu-item:hover.first-menu {
    color: #1F2D3D !important;
  }

  .second-menu.el-menu-item, .second-menu .el-submenu__title {
    font-size: 14px !important;
    height: 50px !important;
    line-height: 42px !important;
  }


  .el-menu--inline .el-menu-item {
    padding-left: 34px !important;
    padding-right: 6px !important;
  }

  .el-menu--inline .el-submenu__title {
    padding-left: 10px !important;
    border-top: none !important;
  }

  .second-menu .el-submenu__title {
    padding-left: 12px !important;
  }

  .el-submenu__title i {
    color: #1f2d3d !important;
  }

  .el-submenu__icon-arrow {
    margin-top: -5px !important;
    right: 19px !important;
    top: 22px !important;
  }

  .first-menu .el-submenu__icon-arrow {
    margin-top: -2px !important;
  }

  .second-menu .el-submenu__icon-arrow {
    margin-top: -2px !important;
  }

  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    -webkit-transform: rotateZ(-90deg) !important;
    transform: rotateZ(-90deg) !important;
  }

  .el-submenu__title:focus,
  .el-submenu__title:hover {
    background-color: #F7FCFF !important;
  }

  .el-menu-item:hover .third-menu-icon,
  .el-menu-item:focus .third-menu-icon,
  .el-menu-item.is-active .third-menu-icon {
    content: '&#xe70b;';
    color: #376088;
  }

  .el-menu-item:hover {
    color: #355F87 !important;
    background: unset !important;
  }

  .menu-list:not(.el-menu--collapse) .el-menu-item:hover .menu-item {
    color: #013769;
    background: #F7FCFF;
    background-blend-mode: normal;
    box-shadow: 0 2px 4px rgba(211, 220, 230, 0.6);
    border-radius: 8px;
    mix-blend-mode: normal;
  }

  .el-menu-item:focus,
  .el-menu-item.is-active {
    color: #355F87 !important;
    background: unset !important;
  }

  .menu-list:not(.el-menu--collapse) .el-menu-item:focus .menu-item, .el-menu-item.is-active .menu-item {
    color: #013769;
    background: rgba(255, 255, 255, 1);
    background-blend-mode: normal;
    box-shadow: 0 2px 4px rgba(211, 220, 230, 0.6);
    border-radius: 8px;
    mix-blend-mode: normal;
  }

  .el-menu-item .menu-item {
    padding: 0 6px !important;
  }

  .second-menu .menu-item {
    height: 42px !important;
    line-height: 42px !important;
  }

  .menu-list:not(.el-menu--collapse) .third-menu .menu-item {
    padding: 0 0 0 36px !important;
  }


  .el-submenu.is-opened .el-menu--popup .el-menu-item > span {
    margin-left: 0 !important;
  }

  .el-submenu.is-opened .el-menu--popup .el-menu-item > span .menu-circular {
    display: none !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened .el-submenu__title {
    background-color: #ffffff !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened.first-menu .el-submenu__title {
    box-shadow: 0 2px 4px rgba(211, 220, 230, 0.3), inset 0px -1px 0px rgba(230, 234, 237, 1);
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened > .el-menu {
    background-color: #F0F6FA !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened > .el-menu {
    background-color: #F0F6FA !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened .second-menu {
    background-color: #F0F6FA !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened .second-menu .el-submenu__title, .menu-list:not(.el-menu--collapse) .second-menu.is-opened .el-submenu__title {
    background-color: #F0F6FA !important;
    box-shadow: unset;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened .third-menu {
    background-color: #E6EBF0 !important;
    box-shadow: unset;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu.is-opened .second-menu:hover .el-submenu__title {
    background-color: #F7FCFF !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu__title {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .el-submenu .el-menu-item {
    padding-left: 6px !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu .el-menu-item {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .menu-list:not(.el-menu--collapse) .el-submenu .el-menu--inline .el-menu-item {
    border-top: none !important;
  }

  .el-menu--popup {
    padding: 0 0 2px 0 !important;
    background: #F9FAFB !important;
    border-radius: 0 !important;
    min-width: 190px !important;
  }

  .el-menu--popup-right-start {
    margin: 0 !important;
    border-radius: 2px !important;
  }

  .el-menu--popup .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    padding: 2px 6px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    border-top: none !important;
    transition-duration: 0s !important;
    -webkit-transition-duration: 0s !important;
    background: #F9FAFB !important;
  }

  .el-menu--popup .second-menu .el-submenu__title {
    border-top: none !important;
    background: #F9FAFB !important;
    padding-right: 0 !important;
  }

  .el-menu--popup .el-menu-item:first-child {
    font-family: "Harmony Medium" !important;
    padding-left: 12px !important;
    height: 46px !important;
    line-height: 46px !important;
    color: #484a50 !important;
    background: rgba(255, 255, 255, 1) !important;
    background-blend-mode: normal;
    box-shadow: 0 2px 4px rgba(211, 220, 230, 0.3), inset 0px -1px 0px rgba(230, 234, 237, 1);
    border-radius: 2px 2px 0 0;
    mix-blend-mode: normal;
  }

  .el-menu--popup .el-menu-item:focus, .el-menu--popup .el-menu-item.is-active {
    background: #EBF4FC !important;
  }

  .el-menu--popup .el-menu-item:focus .menu-item, .el-menu--popup .el-menu-item.is-active .menu-item {
    background: unset !important;
    box-shadow: unset !important;
  }


  .el-menu--popup .el-menu-item .menu-item {
    height: 36px !important;
    line-height: 36px !important;
  }

  .el-menu--popup .el-menu-item:hover .menu-item {
    background: rgba(235, 244, 252, 1);
    background-blend-mode: normal;
    box-shadow: 0 2px 4px rgba(211, 220, 230, 0.6);
    border-radius: 8px;
    mix-blend-mode: normal;
  }

  .el-tooltip {
    padding: unset !important;
  }

  .el-tooltip img {
    margin-left: 14px !important;
  }

  .el-menu-item.is-active, .el-menu-item:focus, .el-menu-item:hover {
    background: unset !important;
  }
}

.side-menu .aside-box-shadow {
  box-shadow: 0 2px 0 rgba(222, 227, 236, 0.80) inset !important;
}
</style>
